module.exports = __webpack_public_path__ + "c58c02fc0c5109c9349d260c453d906e.woff2";